import { render } from "./DocumentCardView.vue?vue&type=template&id=fc817972&scoped=true"
import script from "./DocumentCardView.vue?vue&type=script&lang=js"
export * from "./DocumentCardView.vue?vue&type=script&lang=js"

import "./DocumentCardView.vue?vue&type=style&index=0&id=fc817972&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc817972"]])

export default __exports__